/* Little Rowan cart drawer behaviour: quantity, remove, size change, recommendations ("Pairs well with"), gift note. */
(function () {
  if (window.__lrCart) return; window.__lrCart = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function inner() { return document.querySelector('#CartDrawer .lr-cd'); }
  function busy(on) { var el = inner(); if (el) el.classList.toggle('is-busy', on); }

  function render(sections) {
    if (!sections) return;
    var doc, html;
    if (sections['cart-drawer']) {
      doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      var cur = document.querySelector('#CartDrawer');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      var overlay = document.querySelector('#CartDrawer-Overlay');
      var drawer = document.querySelector('cart-drawer');
      if (overlay && drawer && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
    }
    if (sections['cart-icon-bubble']) {
      doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var src = doc.querySelector('.shopify-section') || doc.body;
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && src) bubble.innerHTML = src.innerHTML;
    }
    loadRecs();
  }

  function post(url, body) {
    busy(true);
    body.sections = SECTIONS;
    body.sections_url = window.location.pathname;
    return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (j) { render(j.sections); return j; })
      .catch(function (err) {
        busy(false);
        var msg = (err && (err.description || err.message)) || 'Something went wrong. Please try again.';
        var el = inner(); if (!el) return;
        var box = el.querySelector('.lr-cd__error');
        if (!box) { box = document.createElement('p'); box.className = 'lr-cd__error'; box.setAttribute('role', 'alert'); box.style.cssText = 'margin:0 2rem;color:#9A5038;font-weight:700;font-size:1.3rem'; var s = el.querySelector('.lr-cd__scroll'); (s || el).insertBefore(box, (s || el).firstChild); }
        box.textContent = msg;
      })
      .finally(function () { busy(false); });
  }

  function line(el) { var li = el.closest('[data-line]'); return li ? Number(li.dataset.line) : null; }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('.lr-cd [data-lr-qty]');
    if (q) { e.preventDefault(); var l = line(q); if (l) post('cart/change.js', { line: l, quantity: Math.max(0, Number(q.dataset.lrQty)) }); return; }
    var a = e.target.closest('.lr-cd [data-lr-rec-add]');
    if (a) {
      e.preventDefault();
      var row = a.closest('.lr-cd__rec'); var sel = row.querySelector('select');
      var id = sel ? sel.value : a.dataset.variant;
      if (id) post('cart/add.js', { items: [{ id: Number(id), quantity: 1 }] });
    }
  });

  document.addEventListener('change', function (e) {
    var s = e.target.closest('.lr-cd [data-lr-swap]');
    if (!s) return;
    var li = s.closest('[data-line]'); var l = Number(li.dataset.line); var qty = Number(li.dataset.qty) || 1; var id = Number(s.value);
    busy(true);
    fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: l, quantity: 0 }) })
      .then(function () { return post('cart/add.js', { items: [{ id: id, quantity: qty }] }); });
  });

  var noteTimer;
  document.addEventListener('input', function (e) {
    var t = e.target.closest('.lr-cd [data-lr-note]');
    if (!t) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: t.value }) });
    }, 500);
  });

  /* "Pairs well with": Shopify's own related-product recommendations for the first item, skipping anything already in the bag. */
  var recCache = {};
  function money(cents) {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP' }).format(cents / 100); }
    catch (e) { return '£' + (cents / 100).toFixed(2); }
  }
  function short(t) { return String(t).replace(/ months?/i, ' M').replace(/ years?/i, ' Y'); }
  function drawRecs(box, list, products) {
    var inCart = (inner().dataset.productIds || '').split(',');
    var picks = products.filter(function (p) { return inCart.indexOf(String(p.id)) === -1 && p.available; }).slice(0, 3);
    if (!picks.length) { box.hidden = true; return; }
    list.innerHTML = '';
    picks.forEach(function (p) {
      var row = document.createElement('div'); row.className = 'lr-cd__rec';
      var img = document.createElement('img'); img.alt = ''; img.loading = 'lazy';
      if (p.featured_image) img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      var info = document.createElement('div'); info.className = 'lr-cd__rec-info';
      var a = document.createElement('a'); a.href = p.url; a.textContent = p.title;
      var price = document.createElement('b'); price.textContent = money(p.price);
      info.appendChild(a); info.appendChild(price);
      var avail = p.variants.filter(function (v) { return v.available; });
      if (p.variants.length > 1) {
        var sel = document.createElement('select'); sel.setAttribute('aria-label', 'Size for ' + p.title);
        avail.forEach(function (v) { var o = document.createElement('option'); o.value = v.id; o.textContent = short(v.title.replace(/ \/ /g, ' · ')); sel.appendChild(o); });
        info.appendChild(sel);
      }
      var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'lr-cd__rec-add'; btn.textContent = 'Add';
      btn.setAttribute('data-lr-rec-add', ''); btn.dataset.variant = avail[0] ? avail[0].id : '';
      btn.setAttribute('aria-label', 'Add ' + p.title);
      row.appendChild(img); row.appendChild(info); row.appendChild(btn);
      list.appendChild(row);
    });
    box.hidden = false;
  }
  function loadRecs() {
    var el = inner(); if (!el) return;
    var box = el.querySelector('[data-lr-recs]'); var list = el.querySelector('[data-lr-recs-list]');
    var pid = el.dataset.firstProduct;
    if (!box || !list || !pid) return;
    if (recCache[pid]) { drawRecs(box, list, recCache[pid]); return; }
    fetch(root + 'recommendations/products.json?product_id=' + pid + '&limit=8&intent=related')
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { recCache[pid] = j.products || []; drawRecs(box, list, recCache[pid]); })
      .catch(function () {});
  }

  /* Product forms re-render the drawer after add-to-cart: refresh recommendations whenever the drawer content changes. */
  function watch() {
    var cd = document.querySelector('#CartDrawer');
    if (!cd) return;
    new MutationObserver(function () { setTimeout(loadRecs, 0); }).observe(cd, { childList: true });
    loadRecs();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
